import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "en",
	ns: ["translations"],
	resources: messages,
	// O React já escapa o texto; escapar aqui estraga datas e acentos
	interpolation: { escapeValue: false },
});

export { i18n };
